import {
  CertificateScopeType,
  CertificateStatusType,
  PeriodUnitType,
  CertificateTypeVisibilityScope,
  RequestScope,
} from '@tabeeb/contracts/microservices/swagger-certificate-service'

export const CertificateStatusTypeDisplayName: Record<CertificateStatusType, string> = {
  [CertificateStatusType.PendingReview]: 'Pending review',
  [CertificateStatusType.Approved]: 'Approved',
  [CertificateStatusType.Rejected]: 'Rejected',
  [CertificateStatusType.Expired]: 'Expired',
  [CertificateStatusType.Draft]: 'Draft',
  [CertificateStatusType.Obsolete]: 'Obsolete',
  [CertificateStatusType.Processed]: 'Processed',
}

export const CertificateScopeTypeDisplayName: Record<CertificateScopeType, string> = {
  [CertificateScopeType.UserCertificate]: 'User', // global scope
  [CertificateScopeType.ProfileCertificate]: 'Profile', // tenant scope
  [CertificateScopeType.TenantCertificate]: 'Tenant',
}

export const PeriodUnitTypeDisplayName: Record<PeriodUnitType, string> = {
  [PeriodUnitType.Day]: 'Day(s)',
  [PeriodUnitType.Month]: 'Month(s)',
  [PeriodUnitType.Year]: 'Year(s)',
}

export const CertificateTypeVisibilityScopeDisplayName: Record<CertificateTypeVisibilityScope, string> = {
  [CertificateTypeVisibilityScope.System]: 'System',
  [CertificateTypeVisibilityScope.Corporation]: 'Corporation',
  [CertificateTypeVisibilityScope.Tenant]: 'Tenant',
}

export {
  CertificateScopeType,
  CertificateStatusType,
  PeriodUnitType,
  CertificateTypeVisibilityScope,
  RequestScope as Scope,
}
